import { render, staticRenderFns } from "./ProductTranslationModal.vue?vue&type=template&id=d3bd639a&"
import script from "./ProductTranslationModal.vue?vue&type=script&lang=js&"
export * from "./ProductTranslationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports